export type VoidFunction = () => void;
export type AsyncVoidFunction = () => Promise<void>;

export const noop = (...args: any[]): void => {};
export const asyncnoop = async (): Promise<void> => {};
